import { inject as compositionInject } from 'vue';
export function useCurrentUser() {
    const provider = compositionInject('userProvider');
    return { user: provider.user, accessToken: provider.access_token };
}
